import React from 'react';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { Box } from '@lifeomic/chroma-react/components/Box';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginRight: theme.spacing(4),
  },
}));

export type ScoringContainerOwnProps = {
  children?: any;
};

export type ScoringContainerProps = ScoringContainerOwnProps;

const ScoringContainer: React.FC<ScoringContainerProps> = ({ children }) => {
  const classes = useStyles({});

  return (
    <>
      <Box justify="flex-end" align="center" className={classes.root}>
        {children}
      </Box>
    </>
  );
};

export default React.memo(ScoringContainer);
